import EventResponseInterface, { SessionResultInterface } from '@/webcomponents/f1-season/store/interface/event';
import { keywordsInBehind } from '@/webcomponents/f1-season/helpers/sort';

export function isDate (date: Date): boolean {
  return !Number.isNaN(date.getHours());
}

export function localizedTimeFromString (timeString: string, countryString: string): string {
  if (typeof timeString !== 'undefined') {
    const timeArray = timeString.split(':');
    if (timeArray.length >= 2) {
      const date = new Date();
      date.setHours(Number(timeArray[0]), Number(timeArray[1]));

      return date.toLocaleTimeString(countryString, {
        hour: 'numeric',
        minute: 'numeric',
      });
    }
  }

  return '–';
}

export function localizedTime (dateString: string, countryString: string): string {
  const date = new Date(dateString);
  if (isDate(date)) {
    return date.toLocaleTimeString(countryString);
  }
  return 'unknown';
}

export function localizedDate (dateString: string, countryString: string): string {
  const date = new Date(dateString);
  if (isDate(date)) {
    return date.toLocaleDateString(countryString);
  }
  return 'unknown';
}

export function raceToViewerTime (nextRace: EventResponseInterface, countryString: string) {
  const nd = new Date(nextRace.raceStart);
  return nd.toLocaleTimeString(countryString, {
    hour: 'numeric',
    minute: 'numeric',
  });
}

export function getBehind (driver: SessionResultInterface) {
  if (driver.time && !keywordsInBehind(driver.behind) && driver.behind.includes('+')) {
    return driver.behind;
  }
  if (driver.time && !driver.behind) {
    return driver.time;
  }
  if (driver.time && !keywordsInBehind(driver.behind)) {
    return `+ ${driver.behind}`;
  }
  if (driver.behind.toLowerCase().indexOf('dnf') !== -1) {
    return 'DNF';
  }
  return Number(driver.laps) > 0 ? 'DNF' : 'DNS';
}

export default {
  isDate,
};
